import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=6e4a483a&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=6e4a483a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a483a",
  null
  
)

export default component.exports